/*
 * Copyright (c) 2026 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import { OrderItem } from '@mta/vela-api-types'

import { PricedBasketItem } from '@/store/basket'

/**
 * Builds the GA4 items for basket lines. GA4 multiplies `price` by `quantity` to get item revenue, so each item carries
 * the price of one unit. A line without a price is sent without one, as the subtotal leaves it out too.
 *
 * @param lines - the basket lines with their prices
 */
const basketGa4Items = (lines: Array<PricedBasketItem>): Array<Gtag.Item> => {
  return lines.map(({ item, price }) => ({
    item_id: item.productId,
    item_name: item.details?.name ?? item.productId,
    quantity: item.quantity,
    price: price?.unitPrice,
    item_variant: item.variantId,
  }))
}

/**
 * Builds the GA4 items for the lines of a confirmed order. VELA prices each line as a whole, in the smallest currency
 * unit, so the price of one unit is the line subtotal divided by the quantity.
 *
 * @param items - the order lines from VELA
 */
const orderGa4Items = (items: Array<OrderItem>): Array<Gtag.Item> => {
  return items.map((item) => ({
    item_id: item.id,
    item_name: item.name,
    quantity: item.quantity,
    price: item.quantity > 0 ? item.price.subtotal / item.quantity / 100 : undefined,
    item_variant: 'language' in item ? item.language : undefined,
  }))
}

export { basketGa4Items, orderGa4Items }
